import { AspectRatio, MediaAsset } from 'libs/contentful/props';
import { getColorway } from 'utils/styles';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import Media from 'components/shared/Media/Media';
import { SharedBentoBoxCardProps } from 'types/sharedComponents';
import { liveUpdateAttrs } from 'libs/contentful/utils';

interface Props extends SharedBentoBoxCardProps {
  icon: MediaAsset;
  aspectRatio?: AspectRatio;
}

const BentoBoxIconCard = ({ sys, color, cardHeadlineRte, copy, icon, aspectRatio }: Props) => {
  return (
    <div
      className={`flex ${getColorway(color)} sm:aspect-3/2 md:aspect-square h-full rounded-lg p-6 sm:col-span-1 col-span-2`}>
      <div className="flex flex-row sm:flex-col sm:justify-between items-center sm:items-start gap-6 sm:gap-0">
        <div className="w-18 h-18 md:h-1/3 md:w-1/3" {...liveUpdateAttrs(sys?.id, 'cardIcon')}>
          <Media
            className="rounded-none sm:w-100"
            media={{
              ...icon,
            }}
            sizes="100px" // Image is maximum of ~87px wide, so 100px is fine
            aspectRatio={aspectRatio}
          />
        </div>

        {/* This is a spacer to ensure the headline & copy are always placed at the bottom */}
        <div className="md:grow" />

        <div className="flex flex-col">
          {cardHeadlineRte && (
            <div className="font-sans font-semibold text-heading-sm" {...liveUpdateAttrs(sys?.id, 'cardHeadlineRte')}>
              <RichTextCopy copy={cardHeadlineRte} />
            </div>
          )}
          {copy && (
            <div className="font-sans font-medium" {...liveUpdateAttrs(sys?.id, 'cardCopy')}>
              <RichTextCopy copy={copy}></RichTextCopy>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BentoBoxIconCard;
